import { Link } from 'react-router-dom';
import type { DeviceRow, DupMatch } from '../types';

function tooltip(title: string, matches: DupMatch[]): string {
  const lines = matches
    .slice(0, 10)
    .map((m) => `• ${m.deviceName || m.deviceSn || `#${m.deviceId}`} (${m.reasons.join(', ')})`);
  const extra = matches.length > 10 ? `\n… et ${matches.length - 10} autre(s)` : '';
  return `${title}\n${lines.join('\n')} (cliquer pour comparer)`;
}

/**
 * Renders duplicate/similarity badges for a device:
 * - amber "doublon" when it shares a hardware/SIM identifier (strong signal),
 * - slate "similaire" for weak hints (same name / same GPS coordinates).
 */
export function DuplicateBadge({ device }: { readonly device: DeviceRow }) {
  const all = device.duplicates ?? [];
  if (all.length === 0) return null;
  const strong = all.filter((m) => m.strong);
  const weak = all.filter((m) => !m.strong);

  return (
    <Link
      to={`/doublons/${device.env}/${device.deviceId}`}
      className="inline-flex items-center gap-1"
      onClick={(e) => e.stopPropagation()}
    >
      {strong.length > 0 && (
        <span
          title={tooltip(
            `Doublon potentiel — partage un identifiant materiel/SIM avec ${strong.length} equipement(s):`,
            strong
          )}
          aria-label="Doublon potentiel"
          className="pill pill-amber cursor-pointer hover:bg-amber-500/20"
        >
          &#9888; doublon{strong.length > 1 ? ` (${strong.length})` : ''}
        </span>
      )}
      {weak.length > 0 && (
        <span
          title={tooltip(
            `Similitude faible avec ${weak.length} equipement(s) (nom ou coordonnees identiques):`,
            weak
          )}
          aria-label="Similitude faible"
          className="pill pill-gray cursor-pointer hov-inset"
        >
          &#8776; similaire{weak.length > 1 ? ` (${weak.length})` : ''}
        </span>
      )}
    </Link>
  );
}
